// extracted by mini-css-extract-plugin
module.exports = {"button":"_2BeRM","commentButton":"_1u3rA","commentButtonIcon":"_1znNn","commentButtonContent":"_283o7","followButton":"_19FeH","followButtonContent":"_2kVYx","container":"_3vOwc"};